import * as React from 'react';
import { useIntl } from 'react-intl';
import { Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { ReactComponent as Envelop } from '@whitelabel/media/icons/envelope.svg';
import { Button, IconCardButton } from '@whitelabel/component-library';
import messages from '../../helpers/messages';
import { StyledRow } from './styledQuickActionsFooter';

const QuickActionsFooter = (): JSX.Element => {
  const { locale, formatMessage } = useIntl();

  return (
    <StyledRow>
      <Col md="6" className="column">
        <div className="column-box">
          <h3 className="h5">{formatMessage(messages.wantToChangeYourProtection)}</h3>
          <Button to={`/${locale}/account`} tag={Link}>
            {formatMessage(messages.manageYourProtection)}
          </Button>
        </div>
      </Col>
      <Col md="6" className="column">
        <IconCardButton
          svgIcon={Envelop}
          link={`/contact-us`}
          title={formatMessage(messages.cantFindAnAnswer)}
          description={formatMessage(messages.contactUsViaForm)}
        />
      </Col>
    </StyledRow>
  );
};

export default QuickActionsFooter;
